import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Home',
      description: 'Aris Heryana — Mobile Developer specializing in Kotlin & Flutter. Crafting apps that feel as good as they look.'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: 'About',
      description: 'Learn about Aris Heryana — 4+ years of mobile development experience with Kotlin, Flutter, and more.'
    }
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('../views/PortfolioView.vue'),
    meta: {
      title: 'Portfolio',
      description: 'Explore mobile apps and projects built by Aris Heryana — Android, Flutter, and web development.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || 'Page') + ' - Aris Heryana';

  // Update meta description per page
  const desc = to.meta.description;
  if (desc) {
    let tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute('content', desc);

    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', desc);
  }

  next();
});

export default router
